import * as ng from 'angular';
import * as _ from 'underscore';

import { TableChart, TableChartFactory, BarChart, Dataset, DatasetField } from '..';

ng.module('e360')
   .factory('npsBarChartFactory', npsBarChartFactory);

npsBarChartFactory.$inject = ['instanceServiceFactory'];
function npsBarChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(NpsBarChart);
}

// Requires that object data has properties named score and registrants
export class NpsBarChart {
   static $inject = ['ds', 'tableChartFactory'];

   barChart:BarChart;
   tableChart:TableChart;
   columnHeaders:string[] = [ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10' ];
   rowHeaders:string[] = ['Handraisers', 'Leads', 'Participants', 'Conquest', 'Loyalty', 'Registrants'];

   constructor(ds:Dataset, tableChartFactory:TableChartFactory) {
      var container = ng.element(`#${ds.id}`);
      container.append(`<div id="${ds.id}-bar" class="chart-component bar-chart"></div>`);
      container.append(`<div id="${ds.id}-table" class="chart-component table-chart"></div>`);

      let options = {
         xAxis: {
            categories: this.columnHeaders
         },
         yAxis: {
            title: {
               text: 'Registrants'
            }
         },
         series: [
            { name: 'NPS Score' }
         ]
      };

      let title = ds.id.indexOf('pre') != -1 ? 'Pre-Ride NPS Distribution' : 'Post-Ride NPS Distribution';
      const newDataSet = new Dataset({id: ds.id + '-bar', title: title});
      this.barChart = new BarChart(newDataSet, options);

      let tableDataset = new Dataset({
         id: ds.id + '-table',
         fields: [
            new DatasetField({
               name: 'name',
               label: '',
               type: 'text'
            })
         ]
      });

      for (let i = 1; i<=options.xAxis.categories.length; i++) {
         tableDataset.fields.push(
            new DatasetField({
               name: i.toString(),
               label: i.toString(),
               type: 'number'
            })
         );
      }

      tableDataset.fields.push(
         new DatasetField({
            name: 'total',
            label: 'Total',
            type: 'number'
         })
      );

      this.tableChart = tableChartFactory({ds: tableDataset});
   }

   setData(data:any[]) {
      let chartData = [];

      for (let score of _.range(1, 11)) {
         let row = _.findWhere(data, {score: score.toString()});
         // data might not have rows for each score, include zeros when missing
         chartData.push(row ? row.registrants : 0);
      }

      this.barChart.setData(chartData);

      let tableData = [];

      // change data from row per score to column per score
      for (let col of this.rowHeaders) {
         let tableRow:any = {name: col};
         tableData.push(tableRow);

         for (let score of _.range(1, 11)) {
            let row = _.findWhere(data, {score: score.toString()});
            // data might not have rows for each score, include zeros when missing
            tableRow[score.toString()] = row ? row[col.toLowerCase()] : 0;
         }

         tableRow.total = _.reduce(_.range(1, 11), (total, i) => total + tableRow[i.toString()], 0);
      }

      this.tableChart.setData(tableData);
   }

   onLoadStart() {
      this.barChart.onLoadStart();
   }

   onLoadFinish() {
      this.barChart.onLoadFinish();
   }
}

export interface NpsBarChartFactory {
   ({ds:Dataset}):NpsBarChart;
}
